export default __webpack_public_path__ + "locales/sr-Latn-RS/UploadPanel.json?hash=f67b741c55472501e46616f02090bd6d";